module.exports = __webpack_public_path__ + "static/img/label-01.7a649a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/thaipost/label-01.png
// module id = svjS
// module chunks = 31